import axios from 'axios';

import { API_URL } from '../config';
import type { ShareLanguage, TaskStatus } from './projectService';

// No Authorization header: the client page is opened without logging in
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface PublicProject {
  language: ShareLanguage;
  project: {
    name: string;
    location: string;
    status: string;
    start_date: string | null;
    end_date: string | null;
  };
  /** Which sections this link shows; a section's data is only sent when it's true. */
  sections: {
    documents: boolean;
    plan: boolean;
    photos_before: boolean;
    photos_after: boolean;
    team_days: boolean;
  };
  documents?: { id: number; name: string; url: string; created_at: string | null }[];
  plan?: {
    done_percentage: number;
    planned_percentage: number;
    tasks: { id: number; title: string; description: string | null; status: TaskStatus; percentage: number }[];
  };
  photos?: {
    id: number;
    type: 'before' | 'after';
    created_at: string | null;
    images: { id: number; url: string; thumbnail_url: string }[];
  }[];
  /** Newest day first; first name + surname initial, no times. */
  team_days?: { date: string; people: { name: string; image_url: string | null }[] }[];
}

export const publicProjectService = {
  /** Throws with `response.status === 404` when the link doesn't exist (or was revoked). */
  async get(token: string): Promise<PublicProject> {
    const response = await api.get(`/public/projects/${encodeURIComponent(token)}`);
    return response.data.data;
  },
};
